<ng-container *transloco="let t">
  @let isSmall = size === Size.SMALL;
  @let toggleClasses =
    !isSmall
      ? 'pl-4! pr-5!'
      : collapsed
        ? 'hover:bg-background-secondary! rounded-xl!'
        : 'hover:bg-background-secondary! gap-3! rounded-xl! pl-3! pr-3!';
  <!-- TODO(core): a textfield-looking `tuiButtonSelect` should get the input text, the hover tint and the open ring from the theme. -->
  <button
    appearance="textfield"
    class="w-full font-normal! enabled:text-text-primary! aria-expanded:-outline-offset-2! aria-expanded:outline-2! aria-expanded:outline-accent-1! data-[collapsed=true]:after:hidden!"
    data-testid="client-picker-toggle"
    tuiButton
    tuiButtonSelect
    tuiChevron
    type="button"
    [attr.data-collapsed]="collapsed"
    [class]="toggleClasses"
    [class.justify-start!]="!collapsed"
    [disabled]="disabled"
    [ngModel]="selectedClient"
    [size]="isSmall ? 's' : 'l'"
    [tuiDropdownLimitWidth]="collapsed ? 'auto' : 'fixed'"
    (ngModelChange)="selectClient($event)">
    <ng-container
      [ngTemplateOutlet]="client"
      [ngTemplateOutletContext]="{ $implicit: selectedClient, hideName: collapsed }" />
    <ng-container *tuiDropdown>
      @if (clientCodes.length > 0) {
        <tui-data-list-wrapper [itemContent]="client" [items]="clientCodes" />
      } @else {
        <p class="p-4 text-center text-sm text-text-tertiary">{{ t("Vous n'avez aucun autre espace.") }}</p>
      }
    </ng-container>
  </button>

  <ng-template #client let-clientCode let-hideName="hideName">
    <pxc-client-image
      class="shrink-0"
      [attr.data-testid]="'client-' + clientCode"
      [class]="isSmall ? 'size-6' : 'size-8'"
      [imagePath]="$safeNavigationMigration(clients[clientCode]?.cdnImagePath)" />
    <span class="line-clamp-2 flex-1 text-start" [animateFade]="!hideName" [class.hidden!]="hideName">
      {{ clients[clientCode]?.fullName }}
    </span>
  </ng-template>
</ng-container>
